<script setup>
	import { ref } from 'vue'
	import QRCode from 'qrcode'
	import { useOrder } from '@/composables/useOrder.js'
	import axios from 'axios'
	
	const props = defineProps({
	  id: {
	    type: Object,
	    required: true
	  }
	})

	const inProcess = ref(false)

	const { order, removeFromOrder, clearOrder } = useOrder()

	const qrCodeDataUrl = ref()
	
	const generateQR = async () => {
		inProcess.value = true;

		const { data } = await axios.post(`${props.id}/orders`, { 
			EstablishmentId : props.id,
			OrderItems : order.value
		})
		
		inProcess.value = false;

		qrCodeDataUrl.value = await QRCode.toDataURL(`https://menui.com.mx/#/order/${props.id}/${data.id}`)

		clearOrder()
	}

	const getItemTotalCost = (item) => {
		return `$${(item.qty * item.price).toFixed(2)}`
	}

	const getOrderTotalCost = () => {
		return `$${order.value.reduce((q, item) => q + (item.qty * item.price), 0)}`
	}

</script>
<template>
	<div class="px-2 mb-4">
		<div v-if="qrCodeDataUrl">
			<small class="text-lg block pt-2 text-gray-800/25 dark:text-white/25 pb-0 font-bold">Hola!</small>
		    <label class="text-4xl pb-2 block font-bold">¡Qué rico!</label>
		    <label class="text-2xl block mb-8 font-thin">Buen apetito</label>
			<div class="bg-white dark:bg-zinc-700 mx-1 my-2 rounded-3xl grow shadow-md shadow-zinc-200/50 dark:shadow-zinc-900/50 border border-zinc-200/50 dark:border-zinc-900/50 flex items-center justify-center py-6">
				<div class="text-center">
	        		<img :src="qrCodeDataUrl" class="w-[270px] m-auto" alt="QR Code" />
	        		<span class="mt-2 block px-1">Muestre el QR al mesero(a)</span>
	        		<small class="block px-1">Mantenga esta ventana hasta que se tome su orden</small>
	        	</div>
	        </div>
		</div>
		<div v-else>
			
			<div v-if="order.length">
				<small class="text-lg block pt-2 text-gray-800/25 dark:text-white/25 pb-0 font-bold">Hola!</small>
		        <label class="text-4xl pb-2 block font-bold">¡Qué rico!</label>
		        <label class="text-2xl block mb-8 font-thin">Buen apetito</label>
				<div class="bg-white dark:bg-zinc-700 mx-1 my-2 rounded-3xl grow shadow-md shadow-zinc-200/50 dark:shadow-zinc-900/50 border border-zinc-200/50 dark:border-zinc-900/50 flex flex-col py-6">
					<div v-for="item in order" :key="item.name" class="mx-6 mb-3">
						<div class="flex items-center p-2">
			        		<span class="px-2 grow">{{ item.qty }} {{ item.name }}</span>
			        		<div class="shrink-0 ps-1">
			        			<span>{{ getItemTotalCost(item) }}</span>
			        			<button 
			        				class="rounded-full w-7 h-7 shadow-md shadow-zinc-200/50 dark:shadow-zinc-900/50 bg-[var(--color)] text-white mx-2" 
			        				@click=removeFromOrder(item.name)
			        				:disabled="inProcess"
			        				:class="{'disabled:bg-zinc-300' : inProcess == true}"
			        			>
			        				-
			        			</button>
			        		</div>
			        	</div>
			        	<hr class="dark:border-zinc-900/50" />
			     	</div>
			     	<div class="flex items-center p-2 mx-6 mb-3 text-xl font-bold">
		        		<span class="px-2">Total</span>
		        		<span class="ms-auto mr-2">{{ getOrderTotalCost() }}</span>
		        	</div>
			     	<button 
			     		class="bg-[var(--color)] text-white rounded-full py-3 px-6 block shadow-md shadow-zinc-200/50 dark:shadow-zinc-900/50 mx-6 mt-3"
			     		@click="generateQR"
			     		:disabled="inProcess"
			     		:class="{'disabled:bg-zinc-300' : inProcess == true}"
			     	>
			     		{{ inProcess==true? 'Generando...' : 'Confirmar Orden' }}
			     	</button>
				</div>
			</div>
			<div v-else class="bg-white dark:bg-zinc-700 mx-1 my-2 rounded-3xl grow shadow-md shadow-zinc-200/50 dark:shadow-zinc-900/50 border border-zinc-200/50 dark:border-zinc-900/50 flex flex-col py-6">
				<div class="text-center">
			      <p class="text-4xl block font-bold text-[var(--color)] mb-4">:)</p>
			      <b class="text-2xl pb-2 block">¿Aun pensando?</b>
			      <small class="font-base text-zinc-600 dark:text-white/50">Aun no has seleccionado nada para ordenar</small>
			    </div>
			</div>

		</div>
	</div>
</template>

